const RECEIPT_ROLES = new Set(["president", "manager", "staff", "part"]);

function normalizeIds(ids) {
  const result=[];
  const seen=new Set();
  (Array.isArray(ids)?ids:[]).forEach(id=>{
    const normalized=String(id??"").trim();
    if(!normalized||seen.has(normalized)) return;
    seen.add(normalized);
    result.push(normalized);
  });
  return result;
}

function legacyHandoverTargets(item, users) {
  const authorId=String(item.author_id);
  return (users||[]).filter(candidate=>
    RECEIPT_ROLES.has(candidate.role)
    && String(candidate.id)!==authorId
    && String(candidate.store||candidate.store_id||candidate.storeId)===String(item.store_id)
  ).map(candidate=>String(candidate.id));
}

function noticeTargets(item, users) {
  const authorId=String(item.author_id);
  return (users||[]).filter(candidate=>{
    if(!RECEIPT_ROLES.has(candidate.role)||String(candidate.id)===authorId) return false;
    const candidateStore=candidate.store||candidate.store_id||candidate.storeId;
    if(item.target==="store") return String(candidateStore)===String(item.store_id);
    if(item.target==="managers") return ["president","manager"].includes(candidate.role);
    if(item.target==="staff_up") return ["president","manager","staff"].includes(candidate.role);
    return item.target==="all";
  }).map(candidate=>String(candidate.id));
}

export function getReceiptStatus(item, users, kind, currentUserId) {
  const hasServerTargets=Array.isArray(item?.target_ids);
  const targetIds=normalizeIds(hasServerTargets
    ?item.target_ids
    :(kind==="handover"?legacyHandoverTargets(item,users):noticeTargets(item,users))
  ).filter(id=>id!==String(item?.author_id));
  const targetSet=new Set(targetIds);
  const readSet=new Set(normalizeIds(item?.reads).filter(id=>targetSet.has(id)));
  const usersById=new Map((users||[]).map(candidate=>[String(candidate.id),candidate]));
  const recipients=targetIds.map(id=>usersById.get(id)||({ id,name:`削除済みユーザー（${id}）` }));
  const readRecipients=recipients.filter(recipient=>readSet.has(String(recipient.id)));
  const unreadRecipients=recipients.filter(recipient=>!readSet.has(String(recipient.id)));
  const meId=String(currentUserId??"");
  const serverIsTarget=typeof item?.receipt_is_target==="boolean"?item.receipt_is_target:null;
  const serverIsRead=typeof item?.receipt_is_read==="boolean"?item.receipt_is_read:null;
  return {
    targetIds,
    readRecipients,
    unreadRecipients,
    isTarget:serverIsTarget??targetSet.has(meId),
    isRead:serverIsRead??readSet.has(meId),
  };
}
